import React, { FC } from 'react';
import { Link } from '@blueprint/link';
import {
    List,
    ListItem,
    StyledLinkItem,
    StyledSection,
    StyledHeading3
} from './NavLinksSection.styles';
import { Props } from './NavLinksSection.types';

const NavLinksSection: FC<React.PropsWithChildren<Props>> = () => {
    const newWindowText = 'This link opens in a new window';
    return (
        <ListItem>
            <StyledSection>
                <StyledHeading3 size="6" color="text-title" isRegular>
                    Explore Zoopla
                </StyledHeading3>
                <List>
                    <StyledLinkItem>
                        <Link
                            href="https://help.zoopla.co.uk/hc/en-gb"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="help"
                        >
                            Help
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/for-sale/"
                            title="For sale"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="for sale"
                        >
                            For sale
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/new-homes/"
                            title="New homes"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="new homes"
                        >
                            New homes
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/discover/property-news/"
                            title="Property news"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="property news"
                        >
                            Property news
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://help.zoopla.co.uk/hc/en-gb"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="contact us"
                        >
                            Contact us
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/to-rent/"
                            title="For rent"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="for rent"
                        >
                            For rent
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/to-rent/commercial/"
                            title="Commercial"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="commercial"
                        >
                            Commercial
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/discover/"
                            title="Guides"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="guides"
                        >
                            Guides
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/sitemap/"
                            title="Sitemap"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="sitemap"
                        >
                            Sitemap
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/house-prices/"
                            title="House prices"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="house prices"
                        >
                            House prices
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/overseas/"
                            title="Overseas"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="overseas"
                        >
                            Overseas
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/postcode-finder/"
                            title="Postcode finder"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="postcode finder"
                        >
                            Postcode finder
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/privacy/"
                            title="Privacy"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="privacy"
                        >
                            Privacy
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            id="cookie_policy"
                            href="/privacy/cookie-policy/"
                            title="Cookie policy"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="cookies"
                        >
                            Cookie policy
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/terms/"
                            title="Terms of use"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="terms of use"
                        >
                            Terms of use
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/slavery-statement/"
                            title="Slavery statement"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="slavery statement"
                        >
                            Slavery statement
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/treehouse/"
                            title="Treehouse"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="treehouse"
                        >
                            Treehouse
                        </Link>
                    </StyledLinkItem>
                </List>
                <StyledHeading3 size="6" color="text-title" isRegular>
                    Build your business
                </StyledHeading3>
                <List>
                    <StyledLinkItem>
                        <Link
                            href="/for-agents-and-developers/"
                            title="Agents & developers"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="agents & developers"
                        >
                            Agents & developers
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://advantage.zpg.co.uk/"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="zoopla_advantage"
                        >
                            Zoopla Advantage
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://www.altosoftware.co.uk/"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="alto_software"
                        >
                            Alto software
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/display/"
                            title="Display advertising"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="display advertising"
                        >
                            Display advertising
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/partnerships/"
                            title="Partnerships"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="partnerships"
                        >
                            Partnerships
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/useful-tools/"
                            title="Useful tools"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="useful tools"
                        >
                            Useful tools
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/about/"
                            title="About us"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="about us"
                        >
                            About us
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/members/terms/"
                            title="Member T&Cs"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="member T&Cs"
                        >
                            Member T&Cs
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="/press/releases/"
                            title="Press"
                            data-track-category="footer"
                            data-track-action="clickthrough"
                            data-track-label="press"
                        >
                            Press
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://pro.zoopla.co.uk/"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="zooplapro"
                        >
                            ZooplaPro
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://realtime-listings.webservices.zpg.co.uk/docs/latest/documentation.html"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="data feeds"
                        >
                            Data feeds
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://careers.zoopla.co.uk/"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="jobs"
                        >
                            Jobs
                        </Link>
                    </StyledLinkItem>
                    <StyledLinkItem>
                        <Link
                            href="https://careers.zoopla.co.uk/tax-strategy/"
                            rel="noopener noreferrer"
                            target="_blank"
                            title={newWindowText}
                            data-track-category="footer"
                            data-track-action="clickout"
                            data-track-label="taxstrategy"
                        >
                            Tax strategy
                        </Link>
                    </StyledLinkItem>
                </List>
            </StyledSection>
        </ListItem>
    );
};

export default NavLinksSection;
